import { PermissionsType } from '@types';
import React from 'react';
import { useSelector } from 'react-redux';

interface PermissionCheckProps {
  permissions:
    | PermissionsType.Permission
    | PermissionsType.PermissionsPartial
    | PermissionsType.Permissions
    | undefined;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

// React Component to check if the user has the required permissions
export const PermissionCheck: React.FC<PermissionCheckProps> = ({
  permissions,
  children,
  fallback = <></>,
}) => {
  if (!permissions || !permissions === undefined || !permissions.length) {
    return <>{children}</>;
  }

  const userPermissions = useSelector(
    (state: any) => state.auth.current.user?.permissions || [],
  );

  const hasPermission = () => {
    if (Array.isArray(permissions)) {
      return permissions.some((permission) =>
        userPermissions.includes(permission),
      );
    }
    return userPermissions.includes(permissions);
  };

  return <>{hasPermission() ? children : fallback}</>;
};

// Usage examples:
// Component usage:
// <PermissionCheck permissions={['can_edit_users', 'can_view_users']}>
//   <Button>Edit User</Button>
// </PermissionCheck>

// Boolean utility usage:
// if (checkPermission('can_edit_users')) {
//   // do something
// }
//
// if (checkPermission(['can_edit_users', 'can_view_users'])) {
//   // do something if user has either permission
// }
